module.exports = __webpack_public_path__ + "img/上海办公室.b4d552dd.jpg";